export const RETRYABLE_ERROR_MESSAGE = 'An error occurred. Please try again.';
export const CANCELLATION_POLICY_HAS_CHANGED_ERROR_MESSAGE =
  "We've encountered an error. " +
  'Something may have changed. ' +
  'Please review the updated cancellation policy and confirm your purchase.';
